import { AppUtils } from './../../utils/app.utils';
import { ConfirmationModalComponent } from './../confirmation-modal/confirmation-modal.component';
import { Component, EventEmitter, HostListener, Inject, Input, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AutoLogoutService } from '@auth/auto-logout-service.service';
import { CustomWorkspaceItemDto } from '@dto/custom-workspace-item.dto';
import { PositionDto } from '@dto/position.dto';
import { WorkspaceItemContentDto } from '@dto/workspace-item-content-dto';
import { WorkspaceNewSaveDto } from '@dto/workspace-new-save-dto';
import { MessageQuoteQuery } from '@model/webFeeder/message-quote-query.model';
import { WorkspaceNewService } from '@services/workspace-new.service';
import { Constants } from '@utils/constants';
import { NotificationsService } from '../../../../node_modules/angular2-notifications';
import { AuthService } from '../../auth/auth.service';
import { CustomWorkspaceItemInterface } from '../../dto/custom-workspace-item-interface.dto';
import { CustomWorkspaceItemMultipleDto } from '../../dto/custom-workspace-item-multiple.dto';
import { ConfigService } from '../../services/webFeeder/config.service';
import { AbstractItemService } from '@business/base/abstract-item.service';
import { AbstractItem } from '@business/base/abstract-item';
import { AuthServer } from '@services/auth-server.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-custom-workspace-modal',
  templateUrl: './custom-workspace-modal.component.html'
})
export class CustomWorkspaceModalComponent extends AbstractItem implements OnInit {
  @Input()
  symbolAutoComplete: string;
  @Input()
  hiddenError: boolean;
  @Output()
  onsymbolChanged = new EventEmitter<MessageQuoteQuery>();
  @Input() override dialog: MatDialog;
  public isRequesting = false;
  public filteredAssets: any;
  public company: string;
  public wksOptSelected: number;
  public loading = false;
  public whithelabel = this.configService.getWhiteLabel();
  public isDev = environment.isDev;

  cardTitles = [
    { id: Constants.WINDOW_NAME_BOOK, title: Constants.TITLE_CARD_BOOK, isCardMarketData: true },
    { id: Constants.WINDOW_NAME_WORK_SHEET, title: Constants.TITLE_CARD_WORKSHEET, isCardMarketData: true },
    { id: Constants.WINDOW_NAME_VOLUME_AT_PRICE, title: Constants.TITLE_CARD_VOLUME_AT_PRICE, isCardMarketData: true },
    { id: Constants.WINDOW_NAME_TIMES_TRADES, title: Constants.TITLE_CARD_TIMES_TRADES, isCardMarketData: true },
    { id: Constants.WINDOW_NAME_ASSET_SUMMARY, title: Constants.TITLE_CARD_ASSET_SUMMARY, isCardMarketData: true },
    { id: Constants.WINDOW_NAME_QUOTE_CHART, title: Constants.TITLE_CARD_QUOTE_CHART, isCardMarketData: true },
    { id: Constants.WINDOW_NAME_NEWS_WKS, title: Constants.TITLE_CARD_NEWS_WKS, isCardMarketData: true },
    { id: Constants.WINDOW_NAME_HIGH_LOW_DAY, title: Constants.TITLE_CARD_HIGH_LOW_DAY, isCardMarketData: true },
    { id: Constants.WINDOW_NAME_POSITION_DAY, title: Constants.TITLE_CARD_POSITION_DAY, isCardMarketData: false },
    { id: Constants.WINDOW_NAME_ORDER_WKS, title: Constants.TITLE_CARD_ORDER_WKS, isCardMarketData: false },
    { id: Constants.WINDOW_NAME_BILLET_ROOT, title: Constants.TITLE_CARD_BILLET_ROOT, isCardMarketData: false },
    { id: Constants.WINDOW_NAME_POSITION_BALANCE, title: Constants.TITLE_CARD_POSITION_BALANCE, isCardMarketData: false },
  ];

  public listCustomWorkspaceDto: Array<CustomWorkspaceItemInterface> = [];
  itemId = 0;

  @HostListener('mousemove')
  onMouseMove() {
    this._autoLogoutService.resetTime();
  }

  @HostListener('click')
  onClick() {
    this._autoLogoutService.resetTime();
  }

  constructor(
    dialog: MatDialog,
    public dialogRef: MatDialogRef<CustomWorkspaceModalComponent>,
    @Inject(MAT_DIALOG_DATA) public override data: any,
    workspaceService: WorkspaceNewService,
    private router: Router,
    private authService: AuthService,
    private notificationService: NotificationsService,
    private configService: ConfigService,
    private _autoLogoutService: AutoLogoutService,
    itemService: AbstractItemService,
    public _NotificationService: NotificationsService,
    private _authServer: AuthServer,
  ) {
    super(workspaceService, dialog, itemService);
    if (this.configService.isLoginMarketData()) {
      const cardTemp = [];
      this.cardTitles.forEach(item => {
        if (item.isCardMarketData) {
          this.configService.writeLog('CustomWorkspace > Card: ' + item.title + ' - isCardMarketData ' + item.isCardMarketData);
          cardTemp.push(item);
        }
      });
      this.cardTitles = cardTemp;
    }
    AppUtils.orderObjectAsc(this.cardTitles, 'title');
    if (!this.authService.isAuthenticated) {
      this.configService.deleteHbBrokerUser();
      this.configService.deleteCookie();
      this.configService.REDIRECT_LOGOUT();
    } else {
      this.symbolAutoComplete = '';
      this.hiddenError = true;
      this.dialog = dialog;
    }
  }

  ngOnInit() { }

  @HostListener('body:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      if (!this.workspaceService.validNumberWorkspace() && this.listCustomWorkspaceDto.length <= 0 && this.data.wksOptSelected === 3) {
        this._NotificationService.info('', Constants.WORKSPACE_MSG001);
        return false;
      } else {
        this.showConfirmClose();
      }
    }
  }

  goBack() {
    this.configService._wksBackModal.next(true);
    this.dialogRef.close(false);
  }

  closeModal(): void {
    this.dialogRef.close(true);
    this.configService._wksBackModal.next(true);
  }

  showConfirmClose() {
    if (this.listCustomWorkspaceDto.length === 0) {
      this.closeModal();
    } else {
      const dialogConfig = this.dialog.open(ConfirmationModalComponent, {
        panelClass: Constants.NORMAL_MODAL
      });
      dialogConfig.componentInstance.title = "Atenção";
      dialogConfig.componentInstance.content = Constants.WORKSPACE_MSG016;
      dialogConfig.afterClosed().subscribe(result => {
        if (result) {
          this.closeModal();
        }
      });
    }
  }

  onAutoCompletAsset(textInput: any) {
    if (textInput.key !== 'ArrowDown' && textInput.key !== 'ArrowUp') {
      this.loading = true;
      let symbolAutoComplete = '';
      if (textInput.target === undefined) {
        symbolAutoComplete = textInput.toLowerCase();
      } else {
        symbolAutoComplete = textInput.target.value.toLowerCase();
      }
      if (symbolAutoComplete) {
        this._authServer.iQuote.quotesQuery(symbolAutoComplete)
          .subscribe(datas => {
            if (datas && datas.length > 0) {
              this.filteredAssets = datas;
            }
          });
      }
      if (
        this.filteredAssets === undefined ||
        this.filteredAssets.length === 0
      ) {
        this.company = '';
      }
      this.loading = false;
      return this.filteredAssets;
    }
  }

  onInputEnter(event) {
    const symbol = event.target.value.toLowerCase();
    this._authServer.iQuote.quotesQuery(symbol).subscribe(datas => {
      if (datas && datas.length > 0) {
        const data = datas.filter(item => item.symbol === symbol.toUpperCase());
        if (data.length === 1) {
          this.onsymbolChanged.emit(datas[0]);
        }
      }
    });
  }

  saveMultiOptionWorkSheet(value: any, currentWorksheet: CustomWorkspaceItemMultipleDto) {
    for (let i = 0; i < value.length; i++) {
      currentWorksheet.assetSymbol.push(value[i].symbol);
      currentWorksheet.company.push(value[i].company);
    }
  }

  saveWorkspace() {
    this.isRequesting = true;
    let nameWorkspace: string;
    this.workspaceService.loadWorkspaces()
      .subscribe(resp => {
        this.loading = true;
        let indexTabNew = 0;
        for (let i = 0; i < resp.length; i++) {
          if (resp[i].IndexTab > indexTabNew) {
            indexTabNew = resp[i].IndexTab;
          }
        }
        indexTabNew = indexTabNew + 1;
        nameWorkspace = this.data.customNameWorkspace;
        const wksNewObj: WorkspaceNewSaveDto = new WorkspaceNewSaveDto(nameWorkspace, [], indexTabNew);
        if (this.listCustomWorkspaceDto.filter(x => x.type === Constants.WINDOW_NAME_WORK_SHEET).length > Constants.QTD_MAX_WORKSHEET) {
          this.notificationService.warn('', Constants.WORKSPACE_MSG012);
          this.isRequesting = false;
        } else {
          for (let i = 0; i < this.listCustomWorkspaceDto.length; i++) {
            const itemSettings = this.workspaceService.getItemDefaultSettings(this.listCustomWorkspaceDto[i].type);
            const wksItemPos: PositionDto = this.workspaceService.mountItemPositionDefaultSettings(itemSettings);
            const wksItemObj: WorkspaceItemContentDto = new WorkspaceItemContentDto(
              i,
              this.listCustomWorkspaceDto[i].assetSymbol.toString(),
              this.listCustomWorkspaceDto[i].company.toString() || '',
              this.listCustomWorkspaceDto[i].type,
              wksItemPos,
              (itemSettings && itemSettings.showInGridster) || false,
              0
            );
            wksNewObj.content.push(wksItemObj);
          }
          this.workspaceService.addWks(wksNewObj).subscribe(data => {
            if (data) {
              this.isRequesting = false;
              this.closeModal();
            }
          });
        }
      });
  }

  hasEqualComponentOnList(symbol: string, type: string, list: any) {
    const node = this.listCustomWorkspaceDto.findIndex(elem =>
      elem.assetSymbol === symbol &&
      elem.type === type);
    if (node === -1) {
      return false;
    } else {
      return true;
    }
  }

  addComponentSelectorInput(value: CustomWorkspaceItemInterface, clearCard?: number) {
    if (clearCard === 1) {
      this.listCustomWorkspaceDto.splice(
        this.listCustomWorkspaceDto.findIndex(elem => elem.id === value.id), 1
      );
    } else {
      let workspaceId;
      if (!this.data || !this.data.customNameWorkspace) {
        workspaceId = this.workspaceService.getWorkspaceSelected();
      } else {
        workspaceId = this.data.wksOptSelected;
      }
      if (this.validateMaxComponents(this.listCustomWorkspaceDto.length, workspaceId.Id)) {
        this.notificationService.warn('', Constants.WORKSPACE_MSG011);
        return;
      }
      if (!this.validateMaxQtdItem(value.type)) {
        let msg = Constants.WORKSPACE_MSG024;
        msg = msg.replace('XXX', value.title);
        this.notificationService.warn('', msg);
        return;
      }
      let cardTemp: any;
      Constants.CARD_CONFIG.forEach(element => {
        if (element.type === value.type) {
          cardTemp = element;
        }
      });
      let qtdItemTemp = 0;
      if (this.listCustomWorkspaceDto && this.listCustomWorkspaceDto.length > 0) {
        this.listCustomWorkspaceDto.forEach(element => {
          if (element.type === cardTemp.type) {
            qtdItemTemp++;
          }
        });
        if (qtdItemTemp >= cardTemp.qtdMax) {
          this._NotificationService.error('', Constants.WORKSPACE_MSG041.replace('[QTD]', cardTemp.qtdMax).replace('[COMP]', cardTemp.name));
          return;
        }
      }
      this.cardTitles.every(card => {
        if (value.type === Constants.WINDOW_NAME_WORK_SHEET || value.type === Constants.WINDOW_NAME_NEWS_WKS
          || value.type === Constants.WINDOW_NAME_HIGH_LOW_DAY || value.type === Constants.WINDOW_NAME_POSITION_DAY
          || value.type === Constants.WINDOW_NAME_ORDER_WKS || value.type === Constants.WINDOW_NAME_POSITION_BALANCE) {
          if (!cardTemp.type || !cardTemp.name) {
            this._NotificationService.error('', 'Não foi possível adicionar a Ferramenta.');
            return false;
          }
          const workSheet = new CustomWorkspaceItemMultipleDto(null, cardTemp.type, [], [], '', false);
          workSheet.id = this.itemId;
          workSheet.title = cardTemp.name;
          this.saveMultiOptionWorkSheet(value, workSheet);
          this.listCustomWorkspaceDto.unshift(workSheet);
          this.itemId++;
          return false;
        } else {
          // if (this.validateOnlyOneAssetAssigned(value.assetSymbol.toString(), value.type, workspaceId.Id) === true
          //   || this.hasEqualComponentOnList(value.assetSymbol.toString(), value.type, this.listCustomWorkspaceDto)) {
          //   this.workspaceService._successAddComponent.next({ 'type': value.type, 'sucess': false });
          //   this._NotificationService.error('Erro', Constants.WORKSPACE_MSG014);
          //   return;
          // }
          if (card.id === value.type) {
            const newItem = new CustomWorkspaceItemDto(
              this.itemId,
              value.type,
              '' + value.assetSymbol,
              '' + value.company,
              card.title,
              false
            );
            this.listCustomWorkspaceDto.unshift(newItem);
            this.workspaceService._successAddComponent.next({ 'type': value.type, 'sucess': true });
            this.itemId++;
            return false;
          }
        }
        return true;
      });
    }
  }

  getItemsWorksheet(worksheet: CustomWorkspaceItemMultipleDto | any): string {
    let list = '';
    worksheet.assetSymbol.forEach((asset, id) => {
      if (id === worksheet.assetSymbol.length - 1) {
        list = list + asset;
      } else {
        list = list + asset + ',';
      }
    });
    return list;
  }

  validateMaxQtdItem(type: string) {
    let wksSelected;
    let cardConfig;
    Constants.CARD_CONFIG.forEach(element => {
      if (element.type === type) {
        cardConfig = element;
      }
    });
    if (!this.data || !this.data.customNameWorkspace) {
      wksSelected = this.workspaceService.getWorkspaceSelected();
    } else {
      wksSelected = this.data.wksOptSelected;
    }
    const userWorkspace = this.workspaceService.getUserWorkspaceById(wksSelected.Id);
    if (userWorkspace && userWorkspace.JsonData && cardConfig && cardConfig.qtdMax !== 0) {
      const workspace = JSON.parse(userWorkspace.JsonData);
      if (workspace.content.filter(x => x.type === cardConfig.type).length +
        this.listCustomWorkspaceDto.filter(x => x.type === cardConfig.type).length >= cardConfig.qtdMax) {
        return false;
      }
    }
    return true;
  }
}
